import React, { Fragment, useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';

const Step2 = ({ formData, setFormData, headers = [], rows = [], selectedHeaders, setSelectedHeaders }) => {
    const updateValue = (key, newValue) => {
        const newData = selectedHeaders.map(item => {
            if (item.key === key) {
                return { ...item, value: newValue };
            }
            return item;
        });

        setSelectedHeaders(newData);
    }

    return (
        <Container className="mt-4">
            <Row className="mb-3">

                <Col xs={6}>
                    <Form.Group className="mb-2">
                        <Form.Control type="text" disabled value="Bedrijfs ID" />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Control type="text" disabled value="Product Omschrijving" />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Control type="text" disabled value="Start Datum" />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Control type="text" disabled value="Eind Datum" />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Control type="text" disabled value="Aantal" />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Control type="text" disabled value="Prijs" />
                    </Form.Group>
                </Col>

                <Col xs={6}>
                    <Form.Group className="mb-2">
                        <Form.Select
                            onChange={(e) => updateValue('company_id', e.target.value)}
                        >
                            <option>Selecteer</option>
                            {headers.map((header, index) => (
                                <option key={index} value={header}>
                                    {header}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Select
                            onChange={(e) => updateValue('description', e.target.value)}
                        >
                            <option>Selecteer</option>
                            {headers.map((header, index) => (
                                <option key={index} value={header}>
                                    {header}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Select
                            onChange={(e) => updateValue('start_date', e.target.value)}
                        >
                            <option>Selecteer</option>
                            {headers.map((header, index) => (
                                <option key={index} value={header}>
                                    {header}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Select
                            onChange={(e) => updateValue('end_date', e.target.value)}
                        >
                            <option>Selecteer</option>
                            {headers.map((header, index) => (
                                <option key={index} value={header}>
                                    {header}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Select
                            onChange={(e) => updateValue('quantity', e.target.value)}
                        >
                            <option>Selecteer</option>
                            {headers.map((header, index) => (
                                <option key={index} value={header}>
                                    {header}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Select
                            onChange={(e) => updateValue('price', e.target.value)}
                        >
                            <option>Selecteer</option>
                            {headers.map((header, index) => (
                                <option key={index} value={header}>
                                    {header}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>

            </Row>
        </Container>
    );

}

export default Step2;
